import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import httpClient from '../../api/httpClient';
import { parseDate } from '../../utils/common';

export type TStatisticData = {
  bankName: string;
  outward: number;
  inward: number;
  transfer: number;
  fx: number;
};

export type TStatistics = {
  data: TStatisticData[];
};

export const fetchStatistics = createAsyncThunk<TStatistics>(
  'statistics/fetch',
  async () => {
    try {
      const valueDate = parseDate(new Date(), 'yyyy-MM-dd');
      const response = await httpClient.get('/api/v1/payments/statistics-by-channel', { params: { valueDate } })
        .then(response => {
          return response.data;
        });
      return await response;
    } catch (e) {
      return console.log('statistics/fetch error' + e);
    }
  }
);

interface DashboadState {
  statistics: TStatisticData[] | null;
  loading: boolean;
  error: boolean;
}

const initialState: DashboadState = {
  statistics: null,
  loading: false,
  error: false,
};

export const dashboadSlice = createSlice({
  name: 'dashboad',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStatistics.fulfilled, (state, action) => {
      state.statistics = action.payload.data;
      state.loading = false;
      state.error = false;
    });
    builder.addCase(fetchStatistics.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export default dashboadSlice.reducer;